import { useState, useEffect, useCallback } from 'react';
import { getSNIESConfig } from '../api/requests/sniesConfig';

export const useSNIESConfig = () => {
  const [sniesEnabled, setSNIESEnabled] = useState<boolean>(false);
  const [mounted, setMounted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const fetchConfig = useCallback(async () => {
    if (loading) {
      return;
    }
    setError(undefined);
    setLoading(true);
    const { data, error } = await getSNIESConfig();
    setSNIESEnabled(!!data?.enabled);
    setError(error ? 'FETCH_ERROR' : undefined);
    setLoading(false);
  }, [loading]);

  useEffect(() => {
    if (!mounted) {
      fetchConfig();
      setMounted(true);
    }
  }, [mounted, fetchConfig]);

  return {
    sniesEnabled,
    error,
    loading,
    mounted,
  };
};
